import * as Scrivito from "scrivito";

function Icon({ icon, size, title, color }) {
  const actualIcon = icon || "las la-university";
  return (
    <i
      className={[actualIcon, size, color].join(" ")}
      aria-hidden="true"
      title={title}
    />
  );
}

function IconComponent({ icon, size, link, color }) {
  const title = (link && link.title()) || "";

  if (!link) {
    return <Icon icon={icon} size={size} title={title} color={color} />;
  }

  return (
    <Scrivito.LinkTag to={link} title={title}>
      <Icon icon={icon} size={size} title={title} color={color} />
    </Scrivito.LinkTag>
  );
}

export default IconComponent;
